import { render, staticRenderFns } from "./AppSidebarProfileMenuItem.vue?vue&type=template&id=679238a4&"
import script from "./AppSidebarProfileMenuItem.vue?vue&type=script&lang=ts&"
export * from "./AppSidebarProfileMenuItem.vue?vue&type=script&lang=ts&"
import style0 from "./AppSidebarProfileMenuItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports